import { useContext } from "react";
import { Step } from "./components";
import { loanSteps, UndergraduateLoanStepContext } from "context/LoanStepContext";

export default function StepsHeader(){
    const {step:currentStep,goToStep} = useContext(UndergraduateLoanStepContext)
    return (
        <div className="flex items-center gap-4 justify-center pt-[1em] p-[1em] z-[100] w-full sticky top-0">
            {loanSteps.map((step,i) => (
                <Step onClick={()=>goToStep(i)} active={currentStep === i} key={step}>{i + 1}</Step>
            ))}
        </div>
    )
}